export default "__VITE_ASSET__BvPxMdca__"